import React, { useEffect, useState } from "react";
import Text from "antd/lib/typography/Text";
import { Button, Image, Progress } from "antd";
import StackedBarChart from "../../components/StackedBar";
import styles from "../../styles/dashboard.module.scss";
import moment from "moment";
import { authSVC } from "../../services";
import { useB2BContext } from "../../context/ContextB2B";
import "./Overview.scss";

function BarChartOverviewAd() {
  const [tapIndex3, setTapIndex3] = useState<number>(0);
  const { getUserByID } = useB2BContext();
  const [yearlyIndexesData, setYearlyIndexesData] = useState<any>();

  useEffect(() => {
    if (getUserByID) {
      authSVC
        .YearlyIndexesData({ company: getUserByID?.company })
        .then((res) => {
          console.log(res?.data?.data.series.length, "03");
          setYearlyIndexesData(res?.data?.data);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }, [getUserByID]);

  return (
    <div className={"overview-card"}>
      <div className="overview-card__header">
        <div className="overview-card__title-row">
          <span
            className="overview-card__dot"
            style={{ background: "#F6EF56" }}
          />
          <h3 className="overview-card__title">Month-on-Month Team Wellbeing</h3>
         
        </div>
        <div className="overview-card__trend">
          <Image src="/figma/up_arrow.svg" preview={false} width={14} />
          <span>85% from last month</span>
        </div>
      </div>

      <div className={styles.title_grp1}></div>
      <div className={styles.graph}>
        {yearlyIndexesData?.series?.[0].data.length === 0 ? (
          <div className="no_data_yet">
            <img src="/img/User_empty.png" alt="" width="56" height="52" />
            <p>No data yet</p>
          </div>
        ) : (
          <StackedBarChart chartData={yearlyIndexesData} />
        )}
      </div>
    </div>
  );
}

export default BarChartOverviewAd;
